import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { syncPreferencesToCookies } from '../../utils/shared/client-preferences';

export interface FinlandFilterState {
  enabled: boolean;
}

const initialState: FinlandFilterState = {
  enabled: typeof window !== 'undefined' ? 
    (() => {
      // Check server preferences first (this should match what server applied)
      const serverClientPreferences = (window as any).__CLIENT_PREFERENCES__;
      const serverIsFinland = serverClientPreferences?.isFinland;
      
      // Always use server preferences if available to match SSR
      if (serverIsFinland !== undefined) {
        // Ensure cookie is set to match the server preference
        if (serverIsFinland) {
          const cookieMatch = document.cookie.match(/(?:^|;\s*)isFinland=([^;]+)/);
          if (!cookieMatch || cookieMatch[1] !== 'true') {
            syncPreferencesToCookies();
          }
        }
        return serverIsFinland;
      }
      
      // Fallback to localStorage only if no server preferences
      const stored = localStorage.getItem('isFinland');
      if (stored !== null) {
        const value = stored === 'true';
        // Ensure cookie is set to match localStorage
        const cookieMatch = document.cookie.match(/(?:^|;\s*)isFinland=([^;]+)/);
        if (!cookieMatch || cookieMatch[1] !== value.toString()) {
          syncPreferencesToCookies();
        }
        return value;
      }
      
      // Default to true - set cookie and localStorage
      localStorage.setItem('isFinland', 'true');
      syncPreferencesToCookies();
      return true;
    })() : true,
};

const finlandFilterSlice = createSlice({
  name: 'finlandFilter',
  initialState,
  reducers: {
    setFinlandFilterEnabled(state, action: PayloadAction<boolean>) {
      state.enabled = action.payload;
      // Sync to localStorage and cookies
      if (typeof window !== 'undefined') {
        localStorage.setItem('isFinland', action.payload.toString());
        syncPreferencesToCookies();
      }
    },
    toggleFinlandFilter(state) {
      state.enabled = !state.enabled;
      // Sync to localStorage and cookies
      if (typeof window !== 'undefined') {
        localStorage.setItem('isFinland', state.enabled.toString());
        syncPreferencesToCookies();
      }
    },
  },
});

export const { setFinlandFilterEnabled, toggleFinlandFilter } = finlandFilterSlice.actions;
export default finlandFilterSlice.reducer; 